// extracted by css-extract-rspack-plugin
module.exports =  {"root":"c97df7f4f8","error":"fd882825aa"};